import React, { useEffect, useState } from "react";
import EACheckbox from "../../shared/Checkbox/EACheckbox";
import useFacility from "../../../../utils/hooks/useFacility";
import useNewsletterConfirmation from "../../NewsletterConfirmation/useNewsletterConfirmation";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import { useTranslation } from "react-i18next";

interface IProps {
  email?: string;
  onAllowMailingChange?: (value: boolean) => void;
}
const CheckBoxNewsletter: React.FC<IProps> = ({ email, onAllowMailingChange }) => {
  const [isNewsletterChecked, setIsNewsletterChecked] = useState(false);
  const { t } = useTranslation();
  const facilityIds = useFacility();
  const { sendInvite } = useNewsletterConfirmation();
  const newsletterActive = useSelector((state: State) => state.config.configuration?.newsLetterActive);
  const privatePolicy = useSelector((state: State) => state.config.configuration?.regulaminList[0].file);
  const labelText = t("Zaznaczając to pole, wyrażam zgodę na otrzymywanie newslettera drogą mailową. Rozumiem i akceptuję warunki <a target='_blank' href='{{privatePolicy}}'>polityki prywatności</a> dotyczące przetwarzania moich danych osobowych.", { privatePolicy: privatePolicy });

  useEffect(() => {
    if (isNewsletterChecked === true && email) {
      setTimeout(() => {
        sendInvite(facilityIds, email);
      }, 2000);
    }
    //eslint-disable-next-line
  }, [email]);

  return (
    <React.Fragment>
      <div style={{ marginTop: "16px" }} className="flex-start-center">
        <h5>{t("dolacz_do_newslettera")}</h5>
      </div>

      {newsletterActive && (
        <EACheckbox
          name="newsletter"
          checked={isNewsletterChecked}
          onChange={(value) => {
            setIsNewsletterChecked(value);
            if (onAllowMailingChange) {
              onAllowMailingChange(value);
            }
          }}
          label={<span dangerouslySetInnerHTML={{ __html: labelText }} />}
        />
      )}
    </React.Fragment>
  );
};

export default CheckBoxNewsletter;
